const Sentry = (<any>window).Sentry || null;
const captureException = (error: any) => Sentry && Sentry.captureException(error);
export { captureException };
